<div class="components-display">


    <!-- Choix Multple -->
    <div *ngIf="Question.type == 1" class="marg-bot">
        <app-multiple-choices [Question]="Question" [SurveyBase]="SurveyBase"></app-multiple-choices>
    </div>
    <!-- Choix Unique -->
    <div *ngIf="Question.type == 2" class="marg-bot">
        <app-unique-choice [Question]="Question" [SurveyBase]="SurveyBase"></app-unique-choice>
    </div>
    <!-- Quantité -->
    <div *ngIf="Question.type == 3" class="marg-bot">
        <app-quantity [Question]="Question" [SurveyBase]="SurveyBase"></app-quantity>
    </div>

    <div *ngIf="Question.type == 4" class="marg-bot">
        <app-free-text [Question]="Question" [SurveyBase]="SurveyBase"></app-free-text>
    </div>

    <div *ngIf="Question.type == 5" class="marg-bot">
        <app-smiley [Question]="Question" [SurveyBase]="SurveyBase"></app-smiley>
    </div>

    <div *ngIf="Question.type == 6" class="marg-bot">
        <app-date [Question]="Question" [SurveyBase]="SurveyBase"></app-date>
    </div>

    <div *ngIf="Question.type == 7" class="marg-bot">
        <app-year [Question]="Question" [SurveyBase]="SurveyBase"></app-year>
    </div>

    <div *ngIf="Question.type == 8" class="marg-bot">
        <app-yes-or-no [Question]="Question" [SurveyBase]="SurveyBase"></app-yes-or-no>
    </div>

    <div *ngIf="Question.type == 10" class="marg-bot">
        <app-hour [Question]="Question" [SurveyBase]="SurveyBase"></app-hour>
    </div>

    <!-- Durée de temps -->
    <div *ngIf="Question.type == 11" class="marg-bot">
        <lib-length-of-time [Question]="Question" [SurveyBase]="SurveyBase"></lib-length-of-time>
    </div>
</div>